const BuyingHistory = () => import('@/views/main/live/buyingHistory/BuyingHistory.vue')
export default {
  path: '/main/live/buyingHistory',
  name: 'BuyingHistory',
  component: BuyingHistory,
  children: []
}
